import React from 'react';
import { CommentDolarIcon, CommentIcon, DolarSIcon, HeartIcon } from '../components/Icons';
import i18n from 'i18next';

const notificationTypes = {
  post_created: {
    icon: <CommentIcon width={16} height={16} />,
    label: i18n.t('created post'),
    text: i18n.t('created post'),
  },
  post_commented: {
    icon: <CommentIcon width={16} height={16} />,
    label: i18n.t('commented on your post'),
    text: i18n.t('commented'),
  },
  post_liked: {
    icon: <HeartIcon width={16} height={16} />,
    label: i18n.t('liked your post'),
    text: i18n.t('liked'),
  },
  user_followed: {
    icon: <DolarSIcon width={16} height={16} />,
    label: i18n.t('subscribed'),
    text: i18n.t('subscribed'),
  },
  purchase: {
    icon: <DolarSIcon width={16} height={16} />,
    label: i18n.t("purchased your post"),
    text: i18n.t('purchased'),
  },
  tip: {
    icon: <CommentDolarIcon width={16} height={16} />,
    label: i18n.t('sent a tip'),
    text: i18n.t('sent a tip'),
  },
  tip_received: {
    icon: <CommentDolarIcon width={16} height={16} />,
    label: i18n.t('sent a tip'),
    text: i18n.t('paid you tip'),
  },
};
export default notificationTypes;
